export function getStatscoreConfig(PALETTE) {
    return {
        Statscore: {
            container: {
                style: {
                    minHeight: 'auto',
                    _mobile_minHeight: 'auto',
                },
            },
            loaderConfig: {
                size: PALETTE.SPINNER_SIZE,
                color1: PALETTE.SPINNER_PRIMARY_COLOR,
                color2: PALETTE.SPINNER_SECONDARY_COLOR,
            },
        },
    };
}
